/* Researched Elements landing: hero stage rotation, formulary scroll and breakdown viewer. */
(() => {
  if (window.__reLanding) return;
  window.__reLanding = true;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const slides = [...root.querySelectorAll('.re-hero__slide')];
    const tabs = [...root.querySelectorAll('.re-hero__tab')];
    if (slides.length < 2) return;
    const secs = Number(root.dataset.interval || 7);
    root.style.setProperty('--re-interval', secs + 's');
    let i = 0, timer = null;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      tabs.forEach((t, k) => {
        t.classList.remove('is-active'); t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) { void t.offsetWidth; t.classList.add('is-active'); }
      });
    };
    const play = () => { if (still) return; clearInterval(timer); timer = setInterval(() => show(i + 1), secs * 1000); root.classList.remove('is-paused'); };
    const pause = () => { clearInterval(timer); root.classList.add('is-paused'); };
    tabs.forEach((t) => t.addEventListener('click', () => { show(Number(t.dataset.go)); play(); }));
    const stage = root.querySelector('.re-hero__stage');
    stage.addEventListener('mouseenter', pause);
    stage.addEventListener('mouseleave', play);
    stage.addEventListener('focusin', pause);
    stage.addEventListener('focusout', play);
    if (still) root.classList.add('is-paused');
    play();
  };

  const initFormulary = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('.re-formulary__track');
    const btns = root.querySelectorAll('.re-round');
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      btns.forEach((b) => { b.disabled = b.dataset.dir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
    };
    btns.forEach((b) => b.addEventListener('click', () => {
      const card = track.querySelector('.re-card');
      const step = card ? card.getBoundingClientRect().width + 18 : 300;
      track.scrollBy({ left: Number(b.dataset.dir) * step * Math.max(1, Math.floor(track.clientWidth / step)), behavior: still ? 'auto' : 'smooth' });
    }));
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();

    const dlg = root.querySelector('.re-viewer');
    const img = dlg.querySelector('.re-viewer__img');
    const cap = dlg.querySelector('.re-viewer__cap');
    root.querySelectorAll('.re-card__more').forEach((b) => b.addEventListener('click', () => {
      img.src = b.dataset.full; img.alt = b.dataset.title + ' full breakdown';
      cap.textContent = b.dataset.title;
      if (dlg.showModal) dlg.showModal(); else window.open(b.dataset.full, '_blank');
    }));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  };

  const bindViewer = (root) => {
    const dlg = root.querySelector('.re-viewer');
    if (!dlg) return;
    const img = dlg.querySelector('.re-viewer__img');
    const cap = dlg.querySelector('.re-viewer__cap');
    root.querySelectorAll('.rc-card__more').forEach((b) => b.addEventListener('click', () => {
      img.src = b.dataset.full; img.alt = b.dataset.title + ' full breakdown';
      cap.textContent = b.dataset.title;
      if (dlg.showModal) dlg.showModal(); else window.open(b.dataset.full, '_blank');
    }));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  };

  const initCatalog = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    bindViewer(root);

    // Highlight the concern pill for the group in view.
    const pills = [...root.querySelectorAll('.rc-pill[data-spy]')];
    if (pills.length && 'IntersectionObserver' in window) {
      const byId = Object.fromEntries(pills.map((p) => [p.dataset.spy, p]));
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          pills.forEach((p) => p.classList.toggle('is-active', p === byId[en.target.id]));
          const pill = byId[en.target.id];
          if (pill) pill.scrollIntoView({ block: 'nearest', inline: 'center', behavior: still ? 'auto' : 'smooth' });
        });
      }, { rootMargin: '-35% 0px -60% 0px' });
      pills.forEach((p) => { const g = document.getElementById(p.dataset.spy); if (g) io.observe(g); });
    }

    // Add to cart without leaving the page; the form still works without JavaScript.
    root.querySelectorAll('form[data-rc-add]').forEach((form) => form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button');
      const label = btn.textContent;
      btn.classList.add('is-busy');
      try {
        const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 're-catalog', data: { source: 're-catalog', itemCount: cart.item_count } } }));
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.textContent = 'Added';
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; }, 2200);
      } catch (err) {
        form.submit();
      }
    }));
  };

  const initVideos = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const dlg = root.querySelector('.vl-player');
    const frame = dlg.querySelector('.vl-player__frame');
    const title = dlg.querySelector('.vl-player__title');
    const ext = dlg.querySelector('.vl-player__ext');
    const close = () => { frame.innerHTML = ''; if (dlg.open) dlg.close(); };
    root.querySelectorAll('[data-play]').forEach((b) => b.addEventListener('click', () => {
      const id = b.dataset.play;
      if (!dlg.showModal) { window.open(b.dataset.url || ('https://rumble.com/embed/' + id + '/'), '_blank'); return; }
      title.textContent = b.dataset.title || '';
      ext.href = b.dataset.url || ('https://rumble.com/embed/' + id + '/');
      const src = id.indexOf('yt:') === 0
        ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id.slice(3)) + '?autoplay=1&rel=0'
        : 'https://rumble.com/embed/' + encodeURIComponent(id) + '/?pub=4&autoplay=2';
      frame.innerHTML = '<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="' + (b.dataset.title || 'Video').replace(/"/g, '&quot;') + '"></iframe>';
      dlg.showModal();
    }));
    dlg.querySelector('.vl-player__close').addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('close', () => { frame.innerHTML = ''; });

    const pills = [...root.querySelectorAll('[data-filter]')];
    const groups = [...root.querySelectorAll('.vl-group')];
    pills.forEach((p) => p.addEventListener('click', () => {
      const f = p.dataset.filter;
      pills.forEach((q) => { const on = q === p; q.classList.toggle('is-active', on); q.setAttribute('aria-selected', on ? 'true' : 'false'); });
      groups.forEach((g) => { g.hidden = f !== 'all' && g.dataset.group !== f; });
    }));
  };

  const initRail = (root) => {
    if (root.dataset.railReady) return;
    root.dataset.railReady = '1';
    const track = root.querySelector('.rail__track');
    const btns = root.querySelectorAll('.re-round');
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      btns.forEach((b) => { b.disabled = b.dataset.dir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
    };
    btns.forEach((b) => b.addEventListener('click', () => {
      const card = track.querySelector('.rc-card');
      const step = card ? card.getBoundingClientRect().width + 20 : 300;
      track.scrollBy({ left: Number(b.dataset.dir) * step * Math.max(1, Math.floor(track.clientWidth / step)), behavior: still ? 'auto' : 'smooth' });
    }));
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();
  };

  const boot = () => {
    document.querySelectorAll('[data-rail]').forEach((r) => { initRail(r); initCatalog(r); });
    document.querySelectorAll('[data-vl]').forEach(initVideos);
    document.querySelectorAll('[data-re-hero]').forEach(initHero);
    document.querySelectorAll('[data-re-formulary]').forEach(initFormulary);
    document.querySelectorAll('[data-rc]').forEach(initCatalog);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => { document.querySelectorAll('[data-ready], [data-rail-ready]').forEach((n) => { delete n.dataset.ready; delete n.dataset.railReady; }); boot(); });
})();
